import { Forms } from '../types';
import { commonForms } from '../common/forms';

export const INForms: Forms = {
  ...commonForms,
  editPhone: [
    [
      {
        name: 'phone',
        type: 'input',
        inputType: 'tel',
        required: true,
      },
    ],
    [
      {
        name: 'save',
        type: 'button',
        buttonType: 'submit',
      },
    ],
  ],
  editProfile: [
    [
      {
        name: 'firstName',
        type: 'input',
        required: true,
      },
    ],
    [
      {
        name: 'lastName',
        type: 'input',
        required: true,
      },
    ],
    [
      {
        name: 'gender',
        type: 'input-radio',
      },
    ],
    [
      {
        name: 'birthday',
        type: 'birthday',
        required: true,
      },
    ],
    [
      {
        name: 'save',
        type: 'button',
        buttonType: 'submit',
      },
    ],
  ],
  checkoutAddress: [
    [
      { name: 'firstName', type: 'input', required: true },
      { name: 'lastName', type: 'input', required: true },
    ],
    [{ name: 'postalCode', type: 'pincode', required: true }],
    [
      {
        name: 'address1',
        type: 'google-address-look-up',
        required: true,
      },
    ],
    [{ name: 'address2', type: 'input' }],
    [{ name: 'city', type: 'input', required: true }],
    [
      { name: 'stateCode', type: 'dropdown', required: true },
      { name: 'countryCode', type: 'dropdown' },
    ],
  ],
  orderLookUpReturns: [
    [
      {
        name: 'orderNo',
        type: 'input',
        inputType: 'text',
        required: true,
      },
    ],
    [{ name: 'phone', type: 'input', inputType: 'tel', required: true }],
    [
      {
        name: 'returnsOrderExplainerModal',
        type: 'text-to-modal',
        required: true,
      },
    ],
    [
      {
        name: 'submitButton',
        type: 'button',
        buttonType: 'submit',
      },
    ],
  ],
};
